import React from 'react';
import './App.css';
import { Nav, Navbar } from 'react-bootstrap'
import { Link, Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import Home from './Home';
import Feedback from './Feedback';
import AboutUs from './AboutUs';
import AddCity from './AddCity';
function App() {      

  return (
    <div className="App">
      <Router>
        <a name="top"></a>
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
          <Navbar.Brand href="/" style={{ fontSize: 24 }}>Get Weather Info</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto" >
              <Nav.Link href="#action/3.1"><Link to="/" style={{color:"grey"}}>Home</Link></Nav.Link>
              <Nav.Link href="#action/3.1"><Link to="/addcity" style={{color:"grey"}}>Search by Cityname</Link></Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link href="#action/3.1"><Link to="/feedback" style={{color:"grey"}}>Feedback</Link></Nav.Link>
              <Nav.Link href="#action/3.1"><Link to="/aboutus" style={{color:"grey"}}>About Us</Link></Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Switch>
          <Route path="/aboutus" component={AboutUs}></Route>
          <Route path="/feedback" component={Feedback}></Route>
          <Route path="/addcity" component={AddCity}></Route>
          <Route path="/" component={Home}></Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
